// Some moment format strings for our different time periods.

const formats = {
    day: {
        long: "LL",
        short: "l"
    },
    week: {
        long: "[Week] W, gggg",
        short: "l"
    },
    month: {
        long: "MMMM YYYY",
        short: "MMM YYYY"
    },
    quarter: {
        long: "[Q]Q YYYY",
        short: "[Q]Q YYYY"
    },
    year: {
        long: "YYYY",
        short: "YYYY"
    }
};

export default formats;
